import { DatePickerDealButtonTheme } from '../../types/components/DatePickerDealButton.types';

export const DATE_PICKER_DEAL_BUTTON_DEFAULT_THEME: DatePickerDealButtonTheme = {
    colors: {
        dealColor: 'accent.base',
        dealBackgroundColor: 'accent.tint.100',
    },
};
